import { render, staticRenderFns } from "./FormVueComponentCrearRegistros.vue?vue&type=template&id=16a52f5e&"
import script from "./FormVueComponentCrearRegistros.vue?vue&type=script&lang=js&"
export * from "./FormVueComponentCrearRegistros.vue?vue&type=script&lang=js&"
import style0 from "./FormVueComponentCrearRegistros.vue?vue&type=style&index=0&id=16a52f5e&prod&lang=css&"
import style1 from "./FormVueComponentCrearRegistros.vue?vue&type=style&index=1&id=16a52f5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports